// extracted by mini-css-extract-plugin
module.exports = {"chip":"az_SLc"};